import { Container, styled } from "@material-ui/core";

export const CustomContainer = styled(Container)(({ theme }) => ({
  position: "relative",
  maxWidth: "640px",
  "&.wide": {
    maxWidth: "700px"
  }
}));
